import castArray from 'lodash/castArray'
import first from 'lodash/first'
import join from 'lodash/join'
import { GetServerSideProps } from 'next'
import React from 'react'

import { CMSPage } from '@Components/CMS/Page'
import { Page, PageType } from '@Generated/graphql'
import { initializeApolloFromContext } from '@Globals/Apollo'
import { useBlockComponents } from '@Globals/CMS/useBlockComponents'
import { PageHOC } from '@Globals/Page/Client'
import { handleRedirect, pageProps } from '@Globals/Page/Server'
import { PageProps } from '@Globals/Page/Types'
import { getSinglePost } from '@Queries/cms/SinglePost.query'

interface Props extends PageProps {
  item: Page
}

type Params = {
  slug: string | string[]
}

export const getServerSideProps: GetServerSideProps<Props, Params> = async (context) => {
  const { params } = context
  const slug = castArray(params?.slug || [])
  const id = first(slug)

  if (!slug || !id) {
    return {
      notFound: true,
    }
  }

  const apolloClient = initializeApolloFromContext(context)
  const post = await getSinglePost(apolloClient, PageType.Career, `/careers/${join(params?.slug, '/')}`, undefined)
  const { page } = post.data

  if (!page) {
    return {
      notFound: true,
    }
  }

  if (page?.type === 'redirect_permanent' || page?.type === 'redirect_temporary') {
    return handleRedirect(context, page.url, page.type)
  }

  return {
    props: {
      ...await pageProps(
        context,
        { type: 'careers', id: '' },
        page,
        ['common', 'cms', 'footer', 'header', 'sidebar', 'products', 'cart'],
      ),
      item: page as Page,
    },
  }
}

const Career = PageHOC<Props>(({ item }) => {
  const components = useBlockComponents(item.blocks || [])

  return (
    <CMSPage>
      {components}
    </CMSPage>
  )
})

export default Career
